import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { VentoutwallService } from "../../_services/ventoutwall.service";
import {CommunityService} from "../../_services/community.service";
import { S3uploadsService } from '../../_services/s3uploads.service';

@Component({
  selector: 'app-add-wall',
  templateUrl: './add-wall.component.html',
  styleUrls: ['./add-wall.component.css']
})
export class AddWallComponent implements OnInit {

  addWallForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  worksheetUrl: string;
  communityDropdownData = [];
  notesFiles:  any[] = [];
  communityList: any[] = [];
  selectedCommunity= [];
  selectedCommunityRoot= [];
  dropdownSettings: any = {};
  anonymous = false;
  allowedVentAccessEmails = [];
  selectedfile1:  Array<File> = [];
  sensitive = false;
  id: string = this.route.snapshot.params.id;

  constructor(private formBuilder: FormBuilder, private router: Router,private S3uploadsService: S3uploadsService, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private ventoutwallservice: VentoutwallService, private CommunityService: CommunityService) { }

  ngOnInit() {
    this.allowedVentAccessEmails = ["arushi@mindpeers.co", "sidshuklakhel@gmail.com", "ketakisnatekar@gmail.com", "shreyar@mindpeers.co"]
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.addWallForm = this.formBuilder.group({
      wall_message: ['', [Validators.required]],
    });
    this.getCommunityList();
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

  }

  get f() { return this.addWallForm.controls; }

  onSelectAll(items: any) {
    items.map(item=>{
      if(!this.selectedCommunity.includes(this.communityList[this.communityDropdownData.indexOf(item)]['_id'])){
        this.selectedCommunity.push(this.communityList[this.communityDropdownData.indexOf(item)]['_id']);
      }
      if(!this.selectedCommunityRoot.includes(this.communityList[this.communityDropdownData.indexOf(item)]['_id'])){
        this.selectedCommunityRoot.push(this.communityList[this.communityDropdownData.indexOf(item)]['_id']);
      }
    })
  }

  onItemSelect(item: any){
    this.selectedCommunity.push(this.communityList[this.communityDropdownData.indexOf(item)]['_id']);
    this.selectedCommunityRoot.push(this.communityList[this.communityDropdownData.indexOf(item)]['_id']);
  }
  OnItemDeSelect(item:any){
    this.selectedCommunity.splice(this.selectedCommunity.indexOf(this.communityList[this.communityDropdownData.indexOf(item)]['_id']),1);
    this.selectedCommunityRoot.splice(this.selectedCommunityRoot.indexOf(this.communityList[this.communityDropdownData.indexOf(item)]['_id']),1);
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.addWallForm.invalid) {
      return;
    }

    const addPayload = {
      wall_message: this.addWallForm.controls.wall_message.value,
      is_anonymous: this.anonymous,
      sensitive: this.sensitive,
      communities: this.selectedCommunity,
      notes: this.notesFiles
    };

    this.addWall(addPayload);

  }

  changeAnonymous() {
    this.anonymous = !this.anonymous;
  }

  changeSensitivity() {
    this.sensitive = !this.sensitive;
  }

  getCommunityList() {
    this.CommunityService.listCommunities()
    .subscribe(
      (data: any) => {
        if (data && data.ResponseCode === '200') {
          this.communityList = data.communityData;
          this.communityDropdownData = data.communityData.map(comm=> comm.name);
        } else {
          this.toaster.showError('Community Fetch', data.ResponseMessage);
          this.communityDropdownData = [];
        }
        // this.router.navigate([this.returnUrl]);
      },
      error => {
        this.toaster.showError('Community Fetch', error.error.ResponseMessage);
      });
  }

  fileUploads1(event) {

    this.selectedfile1 = event.target.files as Array<File>;
    if(this.selectedfile1.length > 1){
      this.toaster.showError('File Upload', "You cannot upload more thank 1 file");
      return;
    } 
    for (let i = 0; i < this.selectedfile1.length; i++) {
      this.uploadFiles1(this.selectedfile1[i]);
    }
  }

  uploadFiles1(filedata) {
    this.S3uploadsService.getSigendUrl({ filename: filedata.name, type: "VENT" , metadata: {appointmentId: this.id}})
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let details = data.urlDetails;
            this.notesFiles.push(details.url);
            this.worksheetUrl = details.url;
            console.log('notesFiles', this.notesFiles);
            this.uploadFileViaUri(details.uri, filedata)
          } else {
            this.toaster.showError('File Upload', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('File Upload', error);
        });
  }

  uploadFileViaUri(uri, payload) {
    this.S3uploadsService.uploadFileViaUri(uri, payload)
      .subscribe(
        (data: any) => {
          // this.toaster.showError('Edit Events', "Image uploaded");
        },
        error => {
          this.toaster.showError('Edit Events Error', error);
        });
  }

  resetValues(){
    this.anonymous = false;
    this.sensitive = false;
    this.selectedCommunity = [];
    this.selectedCommunityRoot = [];
    this.notesFiles = [];
    this.worksheetUrl = "";
  }

  addWall(payload) {
    this.ventoutwallservice.addWall(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.toaster.showSuccess('Add Vent', data.ResponseMessage);
            this.router.navigate([`/wall-list`]);
          } else {
            this.toaster.showError('Add Vent', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Vent', error.error.ResponseMessage);
        });
  }

}
